import './DownloadFiles.scss';

const DownloadFiles = (() => {

})();

export default DownloadFiles;
